// extracted by mini-css-extract-plugin
export default {"container":"store-hours-message__container___1NrN2","time":"store-hours-message__time___3WYGM","closed":"store-hours-message__closed___LnYM7"};